import React, { useEffect, useMemo } from 'react';
import { useParams } from '@tanstack/react-router';
import App from '../../react-app/App';
import { OnboardingProvider } from '../../contexts/OnboardingContext';
import { PromptProvider } from '../../contexts/PromptContext';
import { useDiagramInfo } from '../../hooks/useDiagramInfo';

export const DiagramPage: React.FC = () => {
  const { diagramId } = useParams({ from: '/f/$folderId/d/$diagramId' });

  const effectiveDiagramId = useMemo(() => diagramId ?? 'demo-diagram', [diagramId]);
  const { data: diagramInfo } = useDiagramInfo(effectiveDiagramId);

  useEffect(() => {
    if (diagramInfo?.name) {
      document.title = `${diagramInfo.name} - Creately`;
    }
    return () => { document.title = 'Creately'; };
  }, [diagramInfo?.name]);

  // We pass diagram id via a global var for now; later lift into context/store
  (window as any).__DIAGRAM_ID__ = effectiveDiagramId;
  return (
    <PromptProvider>
      <OnboardingProvider diagramId={effectiveDiagramId}>
        <App />
      </OnboardingProvider>
    </PromptProvider>
  );
};
